module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.da61d7ef302b8bf871dd.svg";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_regular_macroman/Roboto-Regular-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/roboto_regular_macroman/Roboto-Regular-webfont.svg
// module chunks = 1